import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRECIO_HOY } from '../data/oferta';
export function Hero() {
  return <header className="w-full bg-white" data-id="element-38" data-mp="ei1zpycqqp3r">
      <div className="mx-auto max-w-4xl px-5 pb-10 pt-12 text-center sm:pt-16" data-id="element-39" data-mp="9lv0eoeuobus">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-alarm" data-id="element-40" data-mp="4m8n6ez0uvlz">
          Erradicación biológica · Edición 2026
        </p>

        <h1 className="mt-5 text-[2.1rem] font-black leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-41" data-mp="128yz6bncnty4">
          ¿Cansada de luchar contra los piojos{' '}
          <span className="text-flame" data-id="element-42" data-mp="sai3x2hdot69">y perder?</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-43" data-mp="nc87kojx3mj2">
          Elimina los <strong className="font-bold text-ink" data-id="element-44" data-mp="3d1aa1ojbgjfe">“Superpiojos”</strong> en
          menos de 24 horas, sin usar químicos tóxicos y sin gastar una fortuna en
          clínicas.
        </p>

        <p className="mx-auto mt-5 max-w-2xl border-t border-paper-line pt-5 text-base font-semibold leading-relaxed text-ink sm:text-lg" data-id="element-45" data-mp="3j8iw0w4jiat4">
          El único sistema de{' '}
          <span className="bg-flame-soft px-1 text-flame-dark" data-id="element-46" data-mp="3o5j41cky9nmv">
            Erradicación Biológica y Blindaje Familiar
          </span>{' '}
          que garantiza que NO vuelvan jamás.
        </p>

        <div className="mt-9 flex flex-col items-center" data-id="element-47" data-mp="3ebisosz2rm5p">
          <CtaButton data-id="element-48" data-mp="30gzvqx1whaus">👉 Quiero el Megapack por {PRECIO_HOY}</CtaButton>
          <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-ink-muted" data-id="element-49" data-mp="358hmyte4fx2k">
            <ShieldCheckIcon className="h-4 w-4 text-leaf" aria-hidden="true" data-id="element-50" data-mp="2qjv4iit76p74" />
            Garantía de “Cabeza Limpia” de 7 días · Acceso inmediato
          </p>
        </div>
      </div>
    </header>;
}